import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isFunction, isHex, isString, isU8a, stringify, u8aConcatStrict, u8aToU8a } from '@polkadot/util';
import { AbstractArray } from "../abstract/AbstractArray.js";
import { decodeU8a, mapToTypeMap, typeToConstructor } from "../utils/index.js";

function noopSetDefinition(d) {
  return d;
}
/** @internal */


function decodeTuple(registry, result, Classes, value) {
  if (isU8a(value) || isHex(value)) {
    return decodeU8a(registry, result, u8aToU8a(value), Classes);
  }

  var Types = Classes[0];

  for (var i = 0; i < Types.length; i++) {
    try {
      var entry = value === null || value === void 0 ? void 0 : value[i];
      result[i] = entry instanceof Types[i] ? entry : new Types[i](registry, entry);
    } catch (error) {
      throw new Error("Tuple: failed on ".concat(i, ":: ").concat(error.message));
    }
  }

  return [result, 0];
}
/**
 * @name Tuple
 * @description
 * A Tuple defines an anonymous fixed-length array, where each element has its
 * own type. It extends the base JS `Array` object.
 */


var _Types = /*#__PURE__*/new WeakMap();

export var Tuple = /*#__PURE__*/function (_AbstractArray) {
  _inherits(Tuple, _AbstractArray);

  var _super = _createSuper(Tuple);

  function Tuple(registry, Types, value) {
    var _this;

    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        definition = _ref.definition,
        _ref$setDefinition = _ref.setDefinition,
        setDefinition = _ref$setDefinition === void 0 ? noopSetDefinition : _ref$setDefinition;

    _classCallCheck(this, Tuple);

    var Classes = definition || setDefinition(Array.isArray(Types) ? [Types.map(function (t) {
      return typeToConstructor(registry, t);
    }), []] : isFunction(Types) || isString(Types) ? [[typeToConstructor(registry, Types)], []] : mapToTypeMap(registry, Types));
    _this = _super.call(this, registry, Classes[0].length);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _Types, {
      writable: true,
      value: void 0
    });

    var _ref2 = isU8a(value) ? decodeU8a(registry, _assertThisInitialized(_this), value, Classes, false) : decodeTuple(registry, _assertThisInitialized(_this), Classes, value),
        _ref3 = _slicedToArray(_ref2, 2),
        decodedLength = _ref3[1];

    _this.initialU8aLength = decodedLength;

    _classPrivateFieldSet(_assertThisInitialized(_this), _Types, Classes);

    return _this;
  }

  _createClass(Tuple, [{
    key: "encodedLength",
    get:
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    function get() {
      var total = 0;

      for (var i = 0; i < this.length; i++) {
        total += this[i].encodedLength;
      }

      return total;
    }
    /**
     * @description The types definition of the tuple
     */

  }, {
    key: "Types",
    get: function get() {
      var _this2 = this;

      return _classPrivateFieldGet(this, _Types)[1].length ? _classPrivateFieldGet(this, _Types)[1] : _classPrivateFieldGet(this, _Types)[0].map(function (T) {
        return new T(_this2.registry).toRawType();
      });
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return {
        inner: this.inspectInner()
      };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      var _this3 = this;

      var types = _classPrivateFieldGet(this, _Types)[0].map(function (T) {
        return _this3.registry.getClassName(T) || new T(_this3.registry).toRawType();
      });

      return "(".concat(types.join(','), ")");
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      // Overwrite the default toString representation of Array.
      return stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      return u8aConcatStrict(this.toU8aInner(isBare));
    }
  }], [{
    key: "with",
    value: function _with(Types) {
      var definition; // eslint-disable-next-line no-return-assign

      var setDefinition = function setDefinition(d) {
        return definition = d;
      };

      return /*#__PURE__*/function (_Tuple) {
        _inherits(_class, _Tuple);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, Types, value, {
            definition: definition,
            setDefinition: setDefinition
          });
        }

        return _createClass(_class);
      }(Tuple);
    }
  }]);

  return Tuple;
}(AbstractArray);